import React from 'react';
import Brick from './Brick';
import { FormsField } from '../../components';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * handle a form submission server side.
 *
 * [server_side]
 */
class FormHandleBrick extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t, forms } = props;

        if (!forms)
            return null;

        return (
            <FormGroup row>
                <Label for="form_id" className="text-v-center" sm={4}>
                    { t('workflows.bricks.form.handle.options.form_id') }
                </Label>
                <Col sm={8}>
                    <FormsField forms={forms} name={`bricks[${this.position}].options.form_id`} single />
                </Col>
            </FormGroup>
        );
    }
}


export default FormHandleBrick;
